var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-outages-container" }, [
    _vm.outagePageView === "map"
      ? _c("div", { staticClass: "c-outages-container__mapview" }, [
          _c(
            "div",
            { staticClass: "c-outages-container__mapview-wrapper" },
            [
              _c(
                "div",
                { staticClass: "c-outages-container__mapview-outages" },
                [
                  _c("outage-search"),
                  _vm._v(" "),
                  _c("outages-results", {
                    staticClass: "c-outages-container__mapview-results",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-outages-container__mapview-map" },
                [_c("outages-map"), _vm._v(" "), _vm._m(0)],
                1
              ),
              _vm._v(" "),
              _c("outages-messages"),
            ],
            1
          ),
        ])
      : _c(
          "div",
          { staticClass: "c-outages-container__listview" },
          [
            _c("outage-search"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-outages-container__listview-results-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "c-outages-container__listview-results" },
                  [_c("outages-results")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-outages-container__listview-sidebar" },
                  [_c("outages-footer")],
                  1
                ),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "c-outages-container__mapview-map-legend" },
      [
        _c(
          "div",
          { staticClass: "c-outages-container__mapview-map-legend-outage" },
          [
            _c("img", {
              staticClass: "c-outages-container__mapview-map-legend-icon",
              attrs: {
                src: "_resources/app/client/assets/icons/outages-map/unplanned-outage-icon.svg",
              },
            }),
            _vm._v(" "),
            _c(
              "h3",
              { staticClass: "c-outages-container__mapview-map-legend-text" },
              [_vm._v("\n              Unplanned outage\n            ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-outages-container__mapview-map-legend-outage" },
          [
            _c("img", {
              staticClass: "c-outages-container__mapview-map-legend-icon",
              attrs: {
                src: "_resources/app/client/assets/icons/outages-map/planned-outage-icon.svg",
              },
            }),
            _vm._v(" "),
            _c(
              "h3",
              { staticClass: "c-outages-container__mapview-map-legend-text" },
              [_vm._v("\n              Planned outage\n            ")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }